<bz-table uniqueId="service-items"
          appBringozIdGenerator="service-items-table"
          [class.scrollable]="scrollable()"
          [items]="rows()"
          [rowHeight]="60"
          [headerHeight]="33"
          [resizable]="false">
  <ng-template bzTableHeader>
    <div class="th col-type"><span class="br-body-2 font-weight-400">{{ 'Type' | translate }}</span></div>
    @if (columnOn().qty) { <div class="th col-qty"><span class="br-body-2 font-weight-400">{{ 'Qty' | translate }}</span></div> }
    @if (columnOn().dimensions) { <div class="th col-dimensions"><span class="br-body-2 font-weight-400">{{ 'Dimensions' | translate }}</span></div> }
    @if (columnOn().volume) { <div class="th col-volume"><span class="br-body-2 font-weight-400">{{ 'Volume' | translate }}</span></div> }
    @if (columnOn().weight) { <div class="th col-weight"><span class="br-body-2 font-weight-400">{{ 'Weight' | translate }}</span></div> }
    @if (columnOn().description) { <div class="th col-description"><span class="br-body-2 font-weight-400">{{ 'Description' | translate }}</span></div> }
    @if (columnOn().barcode) { <div class="th col-barcode"><span class="br-body-2 font-weight-400">{{ 'Barcode' | translate }}</span></div> }
    @if (columnOn().sku) { <div class="th col-sku"><span class="br-body-2 font-weight-400">{{ 'SKU' | translate }}</span></div> }
    @if (columnOn().value) { <div class="th col-value"><span class="br-body-2 font-weight-400">{{ 'Value' | translate }}</span></div> }
    @if (columnOn().labels) { <div class="th col-labels"><span class="br-body-2 font-weight-400">{{ 'Labels' | translate }}</span></div> }
    @if (columnOn().pallets) { <div class="th col-pallets"><span class="br-body-2 font-weight-400">{{ 'Pallets' | translate }}</span></div> }
    @if (columnOn().packsInItem) { <div class="th col-packs"><span class="br-body-2 font-weight-400">{{ 'Packs In Item' | translate }}</span></div> }
    @for (column of dynamicColumns(); track column.id) {
      <div class="th col-dynamic text-ellipsis">
        <span container="body" [ngbTooltip]="column.title ?? ''"><span class="br-body-2 font-weight-400">{{ column.title }}</span></span>
      </div>
    }
    <div class="th col-actions">
      <bz-button variant="tertiary" size="fit" appBringozIdGenerator="service-items-edit-button" [ariaLabel]="'Edit' | translate" (clicked)="edit.emit()">
        <bz-icon [icon]="icons.edit"></bz-icon>
      </bz-button>
      <app-package-details-settings-panel [settings]="currentSettings()" (settingsChange)="onSettingsChange($event)"></app-package-details-settings-panel>
    </div>
  </ng-template>

  <ng-template bzTableRow let-row>
    @if (row.kind === 'item') {
      <div class="tr item-container" appBringozIdGenerator="service-items-table-row">
        <div class="td col-type layout-row layout-align-start-center">
          @if (row.packageKnown) {
            <!-- ui-fallback: package items stay an admin component. Guarded: unlike the AngularJS one it throws on an unknown type. -->
            <app-bringoz-package-item [id]="row.packageId"></app-bringoz-package-item>
          }
          @if (row.item.attachments?.length) {
            <app-images-link-popup [attachments]="row.item.attachments"></app-images-link-popup>
          }
        </div>
        @if (columnOn().qty) { <div class="td col-qty">{{ row.item.count }}</div> }
        @if (columnOn().dimensions) { <div class="td col-dimensions">{{ row.item.dimensions?.length }}x{{ row.item.dimensions?.width }}x{{ row.item.dimensions?.height }}</div> }
        @if (columnOn().volume) { <div class="td col-volume"><span>{{ [row.item] | servicePackageVolume: true }}</span></div> }
        @if (columnOn().weight) { <div class="td col-weight"><span>{{ [row.item] | servicePackageWeight: true }}</span></div> }
        @if (columnOn().description) {
          <div class="td col-description"><span container="body" [ngbTooltip]="row.item.description ?? ''"><span class="text-ellipsis-multi-lines-2">{{ row.item.description }}</span></span></div>
        }
        @if (columnOn().barcode) {
          <div class="td col-barcode"><span container="body" [ngbTooltip]="row.item.barcode ?? ''"><span class="text-ellipsis">{{ row.item.barcode }}</span></span></div>
        }
        @if (columnOn().sku) {
          <div class="td col-sku"><span container="body" [ngbTooltip]="row.item.sku ?? ''"><span class="text-ellipsis">{{ row.item.sku }}</span></span></div>
        }
        @if (columnOn().value) {
          <div class="td col-value"><span container="body" [ngbTooltip]="row.item.value ? '' + row.item.value : ''"><span class="text-ellipsis">{{ row.item.value | bringozPrice }}</span></span></div>
        }
        @if (columnOn().labels) {
          <div class="td col-labels">
            @if (row.item.labels?.length) { <app-bringoz-labels-display [labels]="row.item.labels" [maxItems]="1"></app-bringoz-labels-display> }
          </div>
        }
        @if (columnOn().pallets) {
          <div class="td col-pallets"><span container="body" [ngbTooltip]="row.item.pallets ? '' + row.item.pallets : ''"><span class="text-ellipsis">{{ row.item.pallets }}</span></span></div>
        }
        @if (columnOn().packsInItem) {
          <div class="td col-packs"><span container="body" [ngbTooltip]="row.item.packsInItem ? '' + row.item.packsInItem : ''"><span class="text-ellipsis">{{ row.item.packsInItem }}</span></span></div>
        }
        @for (column of dynamicColumns(); track column.id) {
          <div class="td col-dynamic text-ellipsis"><span class="br-body-2 text-ellipsis">{{ row.item | bringozPackageCustomDataDisplay: column }}</span></div>
        }
        <div class="td col-actions"></div>
      </div>
    } @else {
      <div class="tr item-container" appBringozIdGenerator="service-items-table-missing-row">
        <div class="td col-type layout-row layout-align-start-center">
          <img height="40" src="assets/images/curved-arrow-right.svg" class="margin-left-10 margin-right-10" alt="">
          <span class="missing-item-text margin-right-5">{{ 'Missing' | translate }}</span>
          <span container="body" [ngbTooltip]="(('X_REPORTED_FROM_BY' | translate: {source: row.item.updatedBy?.source, name: row.item.updatedBy?.name}) + (row.item.comment ? ' · ' + ('Note' | translate) + ': ' + row.item.comment : ''))">
            <bz-icon class="missing-item-icon" [icon]="icons.info"></bz-icon>
          </span>
        </div>
        @if (columnOn().qty) {
          <div class="td col-qty-missing gap-10">
            <span>{{ row.item.quantity }}</span>
            @if (row.attachments) { <app-images-link-popup [attachments]="row.attachments"></app-images-link-popup> }
          </div>
        }
        @if (columnOn().volume) { <div class="td col-volume"></div> }
        @if (columnOn().weight) { <div class="td col-weight"></div> }
        @if (columnOn().description) {
          <div class="td col-description"><span container="body" [ngbTooltip]="row.item.description ?? ''"><span class="text-ellipsis-multi-lines-2">{{ row.item.description }}</span></span></div>
        }
        @if (columnOn().barcode) { <div class="td col-barcode"></div> }
        @if (columnOn().sku) { <div class="td col-sku"></div> }
        @if (columnOn().value) { <div class="td col-value"></div> }
        @for (column of dynamicColumns(); track column.id) { <div class="td col-dynamic"></div> }
        <div class="td col-actions"></div>
      </div>
    }
  </ng-template>

  <bz-empty-state bzTableEmptyState class="service-items-empty-state"
                  [title]="'No Packages Found' | translate"
                  image="assets/images/empty_state/empty_state_dispatching.png">
  </bz-empty-state>
</bz-table>
